/** IoT Manager — grow rooms (gateway-local). */
export const growRoomEndpoints = {
  list: '/v1/iot-manager/grow-rooms',
  one: (id: string) => `/v1/iot-manager/grow-rooms/${id}`,
} as const;
